import WaveEffects from '../components/WaveEffects';
import SpectrumVisualizers from '../components/SpectrumVisualizers';
import CodeTerminals from '../components/CodeTerminals';

/**
 * AmbientLayer - Always-on ambient effects
 * Includes: sine wave with gradient dots, radar visualization, code terminal
 * Disabled on mobile for performance
 */
function AmbientLayer({
  enableAmbientAnimations,
  enableWaveEffects,
  enableSpectrogramVisualizers,
  enableCodeTerminals,
}) {
  if (!enableAmbientAnimations) {
    return null;
  }

  return (
    <div className="animation-layer layer-ambient" data-testid="ambient-layer">
      {enableWaveEffects && <WaveEffects />}
      {enableSpectrogramVisualizers && <SpectrumVisualizers />}
      {enableCodeTerminals && <CodeTerminals />}
    </div>
  );
}

export default AmbientLayer;
